import { PRIORITIES } from '@/modules/relations/common/priorities';

export default {
  computed: {
    prioritiesList() {
      return PRIORITIES;
    }
  }
};
